<template>
  <div class="about-us">
    <div class="container">
      <section class="about-hero">
        <img src="@/assets/daohan-logo.png" alt="道晗漫画平台" class="about-logo">
        <div>
          <p class="eyebrow">ABOUT DAO HAN</p>
          <h1>关于我们</h1>
          <p class="lead">北京道晗科技有限责任公司是一家以技术服务、数字内容制作、软件开发和数字文化创意应用为核心方向的科技企业。</p>
        </div>
      </section>

      <section class="about-card">
        <div class="company-summary">
          <h2>北京道晗科技有限责任公司</h2>
          <p>北京道晗科技有限责任公司成立于2023年03月29日，注册地位于北京市朝阳区豆各庄黄厂西路1号C5栋五层5365，法定代表人为王秀梅。</p>
          <p>公司围绕技术研发、软件开发、数字内容制作、网络与信息安全、图文设计制作、数字文化创意内容应用服务等方向开展业务，致力于以技术能力和内容创意为用户提供稳定、丰富、可信赖的数字服务体验。</p>
        </div>

        <div class="info-grid">
          <div class="info-item">
            <span>成立时间</span>
            <strong>2023年03月29日</strong>
          </div>
          <div class="info-item">
            <span>法定代表人</span>
            <strong>王秀梅</strong>
          </div>
          <div class="info-item wide">
            <span>注册地址</span>
            <strong>北京市朝阳区豆各庄黄厂西路1号C5栋五层5365</strong>
          </div>
          <div class="info-item">
            <span>联系电话</span>
            <strong>15311160987</strong>
          </div>
          <div class="info-item">
            <span>对外投资</span>
            <strong>1家公司</strong>
          </div>
        </div>
      </section>

      <section class="business-card">
        <h2>经营范围</h2>
        <div class="business-groups">
          <div>
            <h3>技术与软件服务</h3>
            <p>技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件开发；物联网技术研发；物联网技术服务；网络技术服务；信息系统运行维护服务；信息系统集成服务；信息技术咨询服务；网络与信息安全软件开发；互联网安全服务。</p>
          </div>
          <div>
            <h3>数字内容与设计</h3>
            <p>专业设计服务；图文设计制作；数字内容制作服务；平面设计；数字文化创意内容应用服务；数字文化创意软件开发；摄像及视频制作服务；影视美术道具置景服务；广告设计、代理；广告制作。</p>
          </div>
          <div>
            <h3>咨询、办公与平台服务</h3>
            <p>办公服务；科技中介服务；科普宣传服务；标准化服务；咨询策划服务；健康咨询服务；人工智能公共服务平台技术咨询服务；人工智能行业应用系统集成服务；基于云平台的业务外包服务；会议及展览服务。</p>
          </div>
          <div>
            <h3>许可业务</h3>
            <p>第一类增值电信业务；第二类增值电信业务；互联网信息服务；网络文化经营。依法须经批准的项目，经相关部门批准后方可开展经营活动。</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style scoped>
.about-us {
  min-height: 100vh;
  padding: 34px 0 58px;
  background:
    radial-gradient(circle at 8% 0%, rgba(255, 204, 102, 0.12), transparent 28%),
    radial-gradient(circle at 92% 12%, rgba(35, 211, 238, 0.1), transparent 30%),
    linear-gradient(180deg, rgba(7, 9, 18, 0.14), rgba(7, 9, 18, 0.62));
}

.container {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
}

.about-hero,
.about-card,
.business-card {
  border: 1px solid rgba(23, 34, 63, 0.08);
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(20, 24, 39, 0.94), rgba(10, 13, 24, 0.96));
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.3);
}

.about-hero {
  display: flex;
  align-items: center;
  gap: 26px;
  padding: 30px;
  margin-bottom: 24px;
}

.about-logo {
  width: 170px;
  height: 122px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  padding: 10px;
  box-shadow: 0 18px 46px rgba(23, 34, 63, 0.12);
}

.eyebrow {
  margin: 0 0 8px;
  color: #0f9fa7;
  font-size: 13px;
  font-weight: 900;
}

.about-hero h1 {
  margin: 0;
  color: #f8fbff;
  font-size: 42px;
  letter-spacing: 0;
}

.lead {
  max-width: 760px;
  margin: 12px 0 0;
  color: #aab5d4;
  font-size: 17px;
  line-height: 1.8;
}

.about-card,
.business-card {
  padding: 30px;
  margin-bottom: 24px;
}

.company-summary h2,
.business-card h2 {
  margin: 0 0 16px;
  color: #f8fbff;
  font-size: 28px;
}

.company-summary p,
.business-groups p {
  margin: 0 0 14px;
  color: #aab5d4;
  font-size: 16px;
  line-height: 1.9;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 22px;
}

.info-item {
  padding: 18px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.info-item.wide {
  grid-column: span 2;
}

.info-item span {
  display: block;
  margin-bottom: 8px;
  color: #23d3ee;
  font-size: 13px;
}

.info-item strong {
  color: #f6f8ff;
  font-size: 16px;
  line-height: 1.5;
}

.business-groups {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.business-groups div {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.business-groups h3 {
  margin: 0 0 10px;
  color: #0f9fa7;
  font-size: 18px;
}

@media (max-width: 820px) {
  .about-hero {
    align-items: flex-start;
    flex-direction: column;
  }

  .info-grid,
  .business-groups {
    grid-template-columns: 1fr;
  }

  .info-item.wide {
    grid-column: auto;
  }

  .about-hero h1 {
    font-size: 34px;
  }
}
</style>
